import { useNavigate } from 'react-router-dom';

import { MovePlannerContent, MovePlannerProvider, type MovePlannerProviderProps } from '@hopdrive/feature-move-planner';

import { productRootPath } from '@features/products/productRoutes';

import { BUILD_SHA, CLIENT_VERSION } from '../../clientVersion';

import { useLaneMapSlot } from './useLaneMapSlot';

type MountProps = Omit<MovePlannerProviderProps, 'onPlanned' | 'clientApp' | 'clientVersion' | 'buildSha'>;

/**
 * The Move Planner as the dealer mounts it: a planned move from the page goes to
 * the moves list, and every submit carries dealer's build identity.
 */
export function DealerMovePlannerProvider(props: MountProps) {
  const navigate = useNavigate();
  return (
    <MovePlannerProvider
      {...props}
      clientApp='dealer'
      clientVersion={CLIENT_VERSION}
      buildSha={BUILD_SHA}
      onPlanned={() => navigate(productRootPath('moves'))}
    />
  );
}

/** The planner's form as the dealer shows it, with the lane map. */
export function DealerMovePlannerContent() {
  const laneMap = useLaneMapSlot();
  return <MovePlannerContent laneMap={laneMap} />;
}
